import { PartnerGroupRules, usePartnerGroupRules } from 'src/graphql';

/**
 * Returns whether the given partner has opted into the new escalation-policy logic.
 * When `false`, escalation-specific UI (category, auto-seeding, evaluation context)
 * should be hidden and the legacy business logic remains in effect.
 */
export function useNewEscalationPoliciesFlag(partnerId: number | undefined): boolean {
  const { partnerGroupRules } = usePartnerGroupRules(partnerId);
  return Boolean(partnerGroupRules?.[PartnerGroupRules.UsesNewEscalationPolicies]);
}
